import Avatar from 'react-avatar'
import styled from 'styled-components'

const PROFILE_IMG_BASE = 'https://media.aumhum.com/images/prod/'

const ProfileCard = styled.div`
  font-family: Outfit, sans-serif;
  padding: 8px 0;
`

const AvatarWrap = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
`

const FieldGroup = styled.div`
  margin-bottom: 16px;
`

const FieldLabel = styled.label`
  display: block;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.04em;
  color: #5c5c7a;
  margin-bottom: 6px;

  .dark-theme & {
    color: rgba(255, 255, 255, 0.6);
  }
`

const FieldValue = styled.div`
  font-size: 15px;
  font-weight: 500;
  color: #1a0a4e;
  padding: 10px 14px;
  background: rgba(32, 7, 105, 0.04);
  border-radius: 10px;
  border: 1px solid rgba(32, 7, 105, 0.06);

  .dark-theme & {
    background: rgba(255, 255, 255, 0.06);
    border-color: rgba(255, 255, 255, 0.08);
    color: rgba(255, 255, 255, 0.9);
  }
`

const GridRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`

const StatusBadge = styled.span`
  display: inline-flex;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 20px;
  background: rgba(34, 197, 94, 0.14);
  color: #16a34a;
`

function ProfileView(props) {
  const profile = props.profile
  if (!profile) return null

  const member = profile.businessMember || {}
  const userProfile = profile.userProfileResponse || {}
  const name = userProfile.name || member.name || '—'
  const email = (member.email || '').replace('@aumhum.xyz', '@vfcorp.com')
  const status = member.status || '—'

  return (
    <ProfileCard>
      <AvatarWrap>
        <Avatar
          name={name}
          src={PROFILE_IMG_BASE + (userProfile.profilePicId || '')}
          size={88}
          round
        />
      </AvatarWrap>

      <FieldGroup>
        <FieldLabel>Full Name</FieldLabel>
        <FieldValue>{name}</FieldValue>
      </FieldGroup>

      <FieldGroup>
        <FieldLabel>Email</FieldLabel>
        <FieldValue>{email || '—'}</FieldValue>
      </FieldGroup>

      <GridRow>
        <FieldGroup>
          <FieldLabel>Package</FieldLabel>
          <FieldValue>{profile.packageName || '—'}</FieldValue>
        </FieldGroup>
        <FieldGroup>
          <FieldLabel>Status</FieldLabel>
          <FieldValue>
            {status === 'active' ? <StatusBadge>{status}</StatusBadge> : status}
          </FieldValue>
        </FieldGroup>
      </GridRow>

      <GridRow>
        <FieldGroup>
          <FieldLabel>Department</FieldLabel>
          <FieldValue>{userProfile.department || '—'}</FieldValue>
        </FieldGroup>
        <FieldGroup>
          <FieldLabel>Designation</FieldLabel>
          <FieldValue>{userProfile.designation || '—'}</FieldValue>
        </FieldGroup>
      </GridRow>
    </ProfileCard>
  )
}

export default ProfileView